import { AuthKeys } from "../utils/authKeys";

export type TokensT = {
  authToken: string;
  refreshToken: string;
};

export const saveLegacyTokens = (tokens: TokensT): void => {
  localStorage.setItem(AuthKeys.accessTokenLegacy, tokens.authToken);
  localStorage.setItem(AuthKeys.refreshTokenLegacy, tokens.refreshToken);
};

export const getLegacyTokens = (): TokensT => {
  return {
    authToken: localStorage.getItem(AuthKeys.accessTokenLegacy) ?? "",
    refreshToken: localStorage.getItem(AuthKeys.refreshTokenLegacy) ?? "",
  };
};

export const hasLegacyTokens = (): boolean => {
  return (
    !!localStorage.getItem(AuthKeys.accessTokenLegacy) &&
    !!localStorage.getItem(AuthKeys.refreshTokenLegacy)
  );
};

export const saveNamekToken = (authToken: string): void => {
  localStorage.setItem(AuthKeys.accessTokenNamek, authToken);
};

export const getNamekToken = (): string => {
  return localStorage.getItem(AuthKeys.accessTokenNamek) ?? "";
};

export const clearTokens = (): void => {
  localStorage.removeItem(AuthKeys.accessTokenLegacy);
  localStorage.removeItem(AuthKeys.refreshTokenLegacy);
  localStorage.removeItem(AuthKeys.accessTokenNamek);
};
